import React, {useState, useEffect} from 'react';
import {Grid , Chip, ListItem, ListItemIcon, ListItemText, Divider} from '@material-ui/core/';
import {AssignmentInd, Today, Person } from '@material-ui/icons';
import { useStyles } from "./style";

//REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// Api Services
import ApiServices from 'services/ApiServices';

function DatosResidenciaElectoralActual(props) {   
    const classes = useStyles()
    return (
    <>
        <Grid container className={classes.marginBotton}>
            <Grid item xs={12}>
                <div className={classes.centerTitle}><Divider /> <strong>RESIDENCIA ELECTORAL ACTUAL EN EL PADRON</strong> <Divider /></div>
            </Grid >
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="DEPARTAMENTO RESIDENCIA" />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>
            </Grid >
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.departamentoDeResidencia?.name} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="MUNICIPIO RESIDENCIA" />
                    <ListItemIcon className={classes.colorIcon}><AssignmentInd/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.municipioDeResidencia?.municipio} />                                
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="COMUNIDAD RESIDENCIA" />
                    <ListItemIcon className={classes.colorIcon}><Person/></ListItemIcon>
                </ListItem>
            </Grid >
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.comunidadResidencia?.name} />                                
            </Grid >                
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="DIRECCIÓN RESIDENCIA" />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.direccion} />                                
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="NO. DE CASA/LOTE" />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.numeroDeCasa ? props.residenciaElectoralActual?.numeroDeCasa : ''} />                                
            </Grid>
            <Grid item xs={3}>
                <ListItem className={classes.rootListItem}>
                    <ListItemText className={classes.rootListItemText} primary="NO. DE ZONA" />
                    <ListItemIcon className={classes.colorIcon}><Today/></ListItemIcon>
                </ListItem>
            </Grid>
            <Grid item xs={3}>
                <Chip variant="outlined" className={classes.colorChip} label={props.residenciaElectoralActual?.numeroDeZona ? props.residenciaElectoralActual?.numeroDeZona : ''} />                                
            </Grid>
        </Grid>
    </>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosResidenciaElectoralActual);